import { Box, Button, Flex, Grid, Link, Stack } from '@chakra-ui/react'
import { useHistory } from 'react-router-dom'
import { Input } from '../components/Form/Input'

import { yupResolver } from '@hookform/resolvers/yup'
import { useContext, useEffect } from 'react'
import { FieldError, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { AuthContext } from '../context/AuthContext'
import { usePermission } from '../hooks/usePermission'
import { routesConfig } from '../routes'
import { cookies } from '../utils/cookies'

export default function SignIn() {
  const history = useHistory()

  const { signIn } = useContext(AuthContext)
  const { hasPermission } = usePermission()

  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        username: yup.string().required('Campo Nome de usuário obrigatório'),
        password: yup.string().required('Campo senha obrigatório'),
      }),
    ),
  })

  const errors = formState.errors

  useEffect(() => {
    if (cookies.get('@AXAuth:Token')) {
      const firstAllowed = routesConfig.find(
        (r) => !r.isPublic && (!r.requiredPermissions || hasPermission(r.requiredPermissions)),
      )
      history.push(firstAllowed?.path || '/dashboard')
    }
  }, [])

  const handleSignIn = async (data) => {
    if (await signIn(data)) {
      const firstAllowed = routesConfig.find(
        (r) => !r.isPublic && (!r.requiredPermissions || hasPermission(r.requiredPermissions)),
      )
      history.push(firstAllowed?.path || '/dashboard')
    }
  }

  return (
    <Flex h="100vh" w="100vw" justifyContent="center" alignItems="center" verticalAlign="middle">
      <Box borderRadius="8" bg="gray.800" p="8" w="25rem">
        <Grid gridTemplateColumns="1fr">
          <Flex as="form" flexDir="column" onSubmit={handleSubmit(handleSignIn)}>
            <Stack>
              <Input label="Nome de usuário" {...register('username')} error={errors.username as FieldError} />
              <Input type="password" label="Senha" {...register('password')} error={errors.password as FieldError} />
            </Stack>

            <Button type="submit" mt="6" colorScheme="pink" size="lg">
              Entrar
            </Button>

            <Box textAlign="center" padding="1rem" color="pink.500" fontSize="sm">
              <Link as="button" onClick={() => history.push('/forgot-password')}>
                <strong>Esqueci minha senha</strong>
              </Link>
            </Box>
          </Flex>
        </Grid>
      </Box>
    </Flex>
  )
}
